
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contract";
import { parallel } from "slotworks/utils/race-utils";

export function WinningSymbolsCommand(symbols: SymbolComponent[], cycling: boolean = false): Contract<void> {
    const winningSymbolWinMethods: Array<() => Contract<void>> = [];

    for (let symbol of symbols) {
        winningSymbolWinMethods.push(() => cycling ? symbol.cycle() : symbol.win());
    }

    return new Contract<void>((resolve) => {
        parallel(winningSymbolWinMethods).then(() => {
            resolve(null);
        });
    });
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/symbols/winning-symbols-command.ts